import styles from './TabButton.module.scss';

interface TabButtonProps {
  tab: string;
  index: number;
  currentTab: number;
  setCurrentTab: (index: number) => void;
}

export default function TabButton({
  tab,
  index,
  currentTab,
  setCurrentTab,
}: TabButtonProps) {
  return (
    <div className={styles.tabButton}>
      <button
        onClick={() => {
          setCurrentTab(index);
        }}
      >
        <div className={styles.inner}>
          <div className={styles.label}>{tab}</div>

          <div className={styles.indicatorDesktop}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="14"
              viewBox="0 0 70 14"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              {currentTab === index && (
                <path
                  d="M2 14C2 12.3431 3.34315 11 5 11H65C66.6569 11 68 12.3431 68 14V14H2V14Z"
                  fill="#EE0000"
                />
              )}
            </svg>
          </div>
          <div className={styles.indicatorMobile}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="14"
              viewBox="0 0 50 14"
              fill="none"
            >
              {currentTab === index && (
                <path
                  d="M2 14C2 12.3431 3.34315 11 5 11H45C46.6569 11 48 12.3431 48 14V14H2V14Z"
                  fill="#EE0000"
                />
              )}
            </svg>
          </div>
        </div>
      </button>
    </div>
  );
}
